import { inject, InjectionToken } from "@angular/core";
import { WINDOW } from "@tylertech/shared-module";

export interface ShellJavaScriptObject
{
    executeAsyncFunction(functionKey: string, modelJson: string): string;
    executeFunction(functionKey: string, modelJson: string): string;
    navigateToShellView(linkId: string): void;
    closeSelfFromShell(navigateToLinkAfterClosing: string): void;
}

export interface ShellAccessProvider
{
    getAccessToken(): string;
    getSystemInfo(): string;
    getLoginViewModel(): string;
}

export interface CefSharpObject
{
    PostMessage<T = unknown>(event: T): void;
}

interface Window extends globalThis.Window
{
    readonly shell?: ShellJavaScriptObject;
    readonly shellAccessProvider?: ShellAccessProvider;
    readonly CefSharp?: CefSharpObject;
}

export const SHELL = new InjectionToken<ShellJavaScriptObject>(
    "Embedded Shell Object",
    {
        providedIn: "root",
        factory: () => (inject(WINDOW) as Window).shell
    });

export const SHELL_ACCESS_PROVIDER = new InjectionToken<ShellAccessProvider>(
    "Embedded Shell Object",
    {
        providedIn: "root",
        factory: () => (inject(WINDOW) as Window).shellAccessProvider
    });

export const CEF_SHARP = new InjectionToken<CefSharpObject>(
    "Embedded Shell Object",
    {
        providedIn: "root",
        factory: () => (inject(WINDOW) as Window).CefSharp
    });
